import { render, staticRenderFns } from "./TestAppLogo.vue?vue&type=template&id=5596c1b6&scoped=true"
import script from "./TestAppLogo.vue?vue&type=script&lang=js"
export * from "./TestAppLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5596c1b6",
  null
  
)

export default component.exports